import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const ClixWall = ({})=> {

  const currentUser = security.currentUserValue;
  const apiKey      = 'YXBRK38C6HYULVFXCQ5L1DA2Y';

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />
      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        src={`https://www.clixwall.com/wall?api=${apiKey}&user=${currentUser}`}
      ></iframe>
    </Fragment>
  );
};

export default ClixWall;
